(ns practitest.frontend.components2.dashboard.charts.bar
  (:require [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.transforms.bar :as transforms]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [re-frame.core :as rf]))

(defn base-spec [chart]
  (let [toggle-evt    #(rf/dispatch [::events/toggle-legend-item (:chart/id chart) %])
        nav-evt       #(rf/dispatch [::events/navigate chart %])
        palette       (:chart/colors-palette chart)
        series-labels (:chart/series chart)
        ordered-range (mapv (fn [label] (get palette label)) series-labels)
        legend?       (not= :no-legend (:chart/legend-location chart))]
    {:mark    :bar
     :padding {:top 5 :right 20 :bottom 35 :left 35}
     :tooltip true
     :data    (:chart/data chart)
     :encode  {:x     {:field :category
                       :type  :nominal
                       :axis  {:label-angle -40}
                       :scale {:domain (:chart/categories chart)
                               :gap    8}}
               :y     {:field :value
                       :type  :quantitative
                       :axis  {:tick-min-step 1}}
               :tooltip {:mode :category-value}
               :color
               (cond-> {:field :group
                        :type  :nominal
                        :scale {:domain series-labels
                                :range  ordered-range}}

                       legend?
                       (assoc :legend {:opacity {:one-of (:chart/inactive-groups chart)}
                                       :offset 60}))}
     :on-legend-click toggle-evt
     :on-bar-click    nav-evt}))

(defmethod p/render! ::chart/bar [chart _ctx svg-element]
  (r/render-chart! svg-element (base-spec chart)))

(defmethod p/transform-data ::chart/bar [chart]
  (transforms/transform chart))
